import './Footer.css'
import React from "react";
import { Link } from "react-router-dom";

function Footer() {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Adds a smooth scrolling effect
        });
    };

    return (
        <footer id='modern-footer'>
            <div className="footer-content">
                
                {/* Brand & Tagline */}
                <div className="footer-section brand-section">
                    <h3 className="footer-name">Arya Taghizadeh</h3>
                    <p className="footer-tagline">Embedded Systems & Hardware Developer</p>
                    <p className="footer-email">
                        <a href="mailto:info@aryatgz.dev">info@aryatgz.dev</a>
                    </p>
                </div>

                {/* Quick Links */}
                <div className="footer-section links-section">
                    <h4>Explore</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/projects">Projects</Link></li>
                        <li><Link to="/skills">Skills</Link></li>
                    </ul>
                </div>

                {/* Social Icons */}
                <div className="footer-section social-section">
                    <h4>Connect</h4>
                    <div className="social-icons">
                        {/* GitHub SVG */}
                        <a href="https://github.com/ariatgz" target="_blank" rel="noreferrer" aria-label="GitHub">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                            </svg>
                        </a>
                        {/* Email SVG */}
                        <a href="mailto:info@aryatgz.dev" aria-label="Email">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                <polyline points="22,6 12,13 2,6"></polyline>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
                <p className="copyright">© 2026 Arya Taghizadeh. All rights reserved.</p>
                <button className="scroll-top-btn" onClick={scrollToTop} aria-label="Scroll to top">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="18 15 12 9 6 15"></polyline>
                    </svg>
                </button>
            </div>
        </footer>
    );
}

export default React.memo(Footer);